import {
  makeStyles, shorthands, tokens,
} from '@fluentui/react-components';

export const useTableViewStyles = makeStyles({
  clearAll: {
    width: '80px',
    justifyContent: 'center',
    "& div[role='presentation']": {
      justifyContent: 'center',
    },
    "& div[role='button']": {
      backgroundColor: 'transparent',
      ...shorthands.border('none'),
      ...shorthands.padding(0),
      color: tokens.colorBrandForegroundLink,
      cursor: 'pointer',
      justifyContent: 'center',
    },
  },
});
